var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mode === 'phone') ? _c('v-form-input', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "readonly": _vm.verified,
      "field": "phone",
      "mask": "phone",
      "label": "Введите телефон"
    },
    scopedSlots: _vm._u([{
      key: "caption",
      fn: function(props) {
        return [(_vm.verified) ? _c('span', [_vm._v("Номер подтвержден")]) : (_vm.timer) ? _c('span', [_vm._v("\n                Отправить код можно через " + _vm._s(_vm.timer) + " " + _vm._s(_vm.seconds) + "\n            ")]) : _c('span', [_vm._v("Мы отправим вам SMS с кодом подтверждения")])]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.mode === 'code') ? _c('div', [_c('v-form-input', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "field": "code",
      "mask": "code",
      "label": "Введите sms-код",
      "autocomplete": "off"
    },
    scopedSlots: _vm._u([{
      key: "error",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.errorCode || props.error))]
      }
    }, {
      key: "caption",
      fn: function(props) {
        return [_c('v-row', [_c('v-col', {
          directives: [{
            name: "padding",
            rawName: "v-padding.right",
            value: (0),
            expression: "0",
            modifiers: {
              "right": true
            }
          }],
          attrs: {
            "xs": "7"
          }
        }, [(_vm.timer) ? _c('span', [_vm._v("\n                            Отправить код можно через " + _vm._s(_vm.timer) + " " + _vm._s(_vm.seconds) + "\n                        ")]) : _c('v-link', {
          attrs: {
            "to": "javascript:;"
          },
          nativeOn: {
            "click": function($event) {
              _vm.handleSendCode($event)
            }
          }
        }, [_vm._v("\n                            Отправить код повторно\n                        ")])], 1), _vm._v(" "), _c('v-col', {
          directives: [{
            name: "text-align",
            rawName: "v-text-align.right",
            modifiers: {
              "right": true
            }
          }, {
            name: "padding",
            rawName: "v-padding.left",
            value: (0),
            expression: "0",
            modifiers: {
              "left": true
            }
          }]
        }, [_c('v-link', {
          attrs: {
            "to": "javascript:;"
          },
          nativeOn: {
            "click": function($event) {
              _vm.isShowModal = true
            }
          }
        }, [_vm._v("\n                            Не приходит SMS?\n                        ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-link', {
          attrs: {
            "to": "javascript:;"
          },
          nativeOn: {
            "click": function($event) {
              _vm.handleResetPhone($event)
            }
          }
        }, [_vm._v("\n                            Изменить номер\n                        ")])], 1)], 1)]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'phone' && !_vm.verified) ? _c('v-green-button', {
    attrs: {
      "type": "button",
      "primary": "",
      "block": "",
      "disabled": _vm.invalidPhone || _vm.disabled || !!_vm.timer
    },
    on: {
      "click": _vm.handleSendCode
    }
  }, [_vm._v("\n        отправить код\n    ")]) : _vm._e(), _vm._v(" "), (_vm.mode === 'code') ? _c('v-spinner', {
    attrs: {
      "block": "",
      "active": _vm.loader
    }
  }, [_c('v-green-button', {
    attrs: {
      "disabled": _vm.invalidCode || _vm.disabled,
      "primary": "",
      "block": ""
    },
    on: {
      "click": _vm.handleConfirmCode
    }
  }, [_vm._v("\n            подтвердить\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-modal', {
    attrs: {
      "active": _vm.isShowModal
    },
    on: {
      "close": function($event) {
        _vm.isShowModal = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n                    Не приходит SMS?\n                ")])], 1), _vm._v(" "), _c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n                Принимаем звонки ПН - ПТ, с 10:00 до 18:00 (МСК)\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "primary": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.isShowModal = false
      }
    }
  }, [_vm._v("\n                    закрыть\n                ")])], 1)], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa04226c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/FormPhoneVerify.vue
// module id = 847
// module chunks = 0